export default __webpack_public_path__ + "static/stop_go-f3a3032e068ba2cfbca2267150f6659a.gif";